import React from 'react';
import PropTypes from 'prop-types';
import useGetUser from '../../hooks/useGetUser';
import PasswordChangeRequiredNotice from './PasswordChangeRequiredNotice';

/**
 * ITGC 10.1a — Fuerza el cambio de contraseña cuando hay uno pendiente.
 *
 * El disparador es evidencia de compromiso del autenticador, no la antigüedad de la
 * contraseña: NIST SP 800-63B §5.1.1.2 recomienda NO exigir cambios periódicos, pero
 * SÍ obliga a forzarlos ante compromiso.
 *
 * Envuelve el árbol autenticado y lo reemplaza, en vez de superponerse a él. El backend
 * bloquea todos los root fields salvo los del flujo por correo, así que si la app
 * siguiera montada dispararía decenas de queries que fallan con `password_change_required`
 * detrás del aviso. Reemplazarla es también lo único que garantiza que no quede nada
 * más a la vista.
 *
 * Los usuarios federados (Entra ID) nunca traen `passwordChangeRequired` en true, así
 * que su experiencia no se ve interrumpida.
 */
const PasswordChangeGuard = ({ children }) => {
  const user = useGetUser();

  if (!user?.passwordChangeRequired) return <>{children}</>;

  return <PasswordChangeRequiredNotice email={user.email} />;
};

PasswordChangeGuard.propTypes = {
  children: PropTypes.node,
};

PasswordChangeGuard.defaultProps = {
  children: null,
};

export default PasswordChangeGuard;
